
export const isVideo = (mimeType): boolean => mimeType.includes("video");
export const isPDF = (mimeType): boolean => mimeType === "application/pdf";
export const isImage = (mimeType): boolean => [
  "image/apng", "image/bmp", "image/gif",
  "image/x-icon", "image/jpeg", "image/png",
  "image/svg+xml", "image/tiff", "image/webp",
].includes(mimeType);